import PropTypes from 'prop-types';

import { useLocale } from 'lib/localeProvider';
import { TRACK_CATEGORIES } from 'lib/tracking';

import ButtonNew from 'components/shared/Button/ButtonNew';
import Link from 'components/shared/Link/Link';

import content from './CtaButton.content';

/**
 * A call-to-action button for the website's main lead.
 */
function CtaButton({ trackLabel, ...restProps }) {
  const { localeCode } = useLocale();
  const localeContent = content[localeCode];
  const redirectLink =
    localeCode === 'uk'
      ? 'https://minuteful.com/uk/uti/boots/locate-pharmacy'
      : 'https://minuteful.com/uk/uti/nhs/locate-pharmacy';

  return (
    <ButtonNew
      as={Link}
      href={redirectLink}
      track={{
        event: localeContent?.locatePharmacyBtnText,
        category: TRACK_CATEGORIES.CTA_CLICK,
        label: trackLabel,
      }}
      {...restProps}
    >
      {localeContent?.locatePharmacyBtnText}
    </ButtonNew>
  );
}

CtaButton.propTypes = {
  trackLabel: PropTypes.string,
};

export default CtaButton;
